import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  IconButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";
import PermissionTable from "./PermissionTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const AddProfilePage = ({
  onClose,
  onProfileAdded,
}) => {
  const [profileName, setProfileName] = useState("");
  const [description, setDescription] = useState("");
  const [permissions, setPermissions] = useState({});
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [loading, setLoading] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
const [actionClicked, setActionClicked] = useState(null); 
  const instanceAlias = localStorage.getItem("instanceName");
  const email = localStorage.getItem("Email");
  const instanceId = localStorage.getItem("InstanceId");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");

  const togglePermission = (key) => {
    setPermissions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const normalizePermission = (perm) => {
    // Convert dashes into dot + PascalCase
    return perm.replace(/-([a-z])/gi, (_, c) => "." + c.toUpperCase());
  };

  const formatPermissionsForAPI = (permObj) => {
    return Object.entries(permObj)
      .filter(([_, value]) => value) // only include checked/true permissions
      .map(([key]) => normalizePermission(key));
  };

  const handleProfileNameChange = (e) => {
    setProfileName(e.target.value);
    setError(false);
    setHelperText("");
  };

  const handleCancel = () => {
    setActionClicked("cancel");
    setCancelButtonLoading(true);
    setTimeout(() => {
      setCancelButtonLoading(false);
      setActionClicked(null);
      onClose();
    }, 500);
  };

  const AddSecurityProfiles = async () => {
    const regex = /^[A-Za-z0-9 _@-]{1,127}$/;

    if (!profileName || profileName.trim() === "") {
  setError(true);
  setHelperText("Name is required.");
  return;
}

if (!regex.test(profileName)) {
  setError(true);
  setHelperText(
    "Invalid name: Only A-Z, 0-9, spaces, @, _ and - allowed. Max 127 characters."
  );
  return;
}

    const selectedPermissions = formatPermissionsForAPI(permissions);
    
    console.log("🔄 Formatted permissions for API:", selectedPermissions);

    const payload = {
      action: "createSecurityProfile",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
      securityProfileName: profileName,
      securityProfileDescription: description,
      permissions: selectedPermissions
    };

    try {
         setActionClicked("save");
      setLoading(true);
      const response = await axiosInstance.post(
        endpoints.displaysecurityprofile.securityprofile,
        payload
      );

      const parsed = JSON.parse(response.data?.body || "{}");
      const newProfile = {
        securityProfileARN: parsed.Arn || "",
        securityProfileId: parsed.Id || "",
        name: profileName,
        description,
        permissions: selectedPermissions,
        tags: parsed.Tags || {},
        allowedAccessControlTags: parsed.AllowedAccessControlTags || {},
        lastModifiedTime: parsed.LastModifiedTime || new Date().toISOString(),
        instanceId: instanceId
      };

      onProfileAdded(newProfile);
      onClose();
    } catch (err) {
      console.error("Failed to add profile:", err);
      
      // Enhanced error handling consistent with Edit page
      if (err.response?.status === 400) {
        try {
          const errorBody = JSON.parse(err.response.data?.body || "{}");
          if (errorBody.invalidPermissions) {
            setHelperText(`Invalid permissions: ${errorBody.invalidPermissions.join(", ")}`);
            console.error("❌ Invalid permissions:", errorBody.invalidPermissions);
          } else {
            setHelperText(errorBody.error || "Failed to create profile.");
          }
        } catch (parseError) {
          setHelperText("Failed to create profile.");
        }
      } else {
        setHelperText("Failed to create profile.");
      }
      setError(true);
    } finally {
      setLoading(false);
         setActionClicked(null);
    }
  };

  // ✅ CORRECTED Permission sections - ONLY valid permissions (removed Amazon Q)
  const permissionSections = [
    {
      id: 'routing',
      title: 'Routing',
      description: 'These permissions are for configuring access to different agent routing capabilities.',
      items: [
        { id: 'RoutingPolicies', label: 'Routing profiles' },
        { id: 'HoursOfOperation', label: 'Hours of operation' },
        { id: 'Queues', label: 'Queues' },
        { id: 'TaskTemplates', label: 'Task templates' },
        { id: 'PredefinedAttributes', label: 'Predefined attributes' }
      ],
      hasEnableDisable: true,
    },
    {
      id: 'security',
      title: 'Security Profiles',
      description: 'These permissions are for managing security profiles.',
      items: [
        { id: 'SecurityProfiles', label: 'Security Profiles' },
      ],
      hasEnableDisable: false,
    },
    {
      id: 'users',
      title: 'User Management',
      description: 'These permissions are for managing users and agent hierarchy.',
      items: [
        { id: 'AgentGrouping', label: 'Agent hierarchy' },
      ],
      hasEnableDisable: true,
    },
    {
      id: 'agent-states',
      title: 'Agent States',
      description: 'These permissions are for managing agent states.',
      items: [
        { id: 'AgentStates', label: 'Agent States' },
      ],
      hasEnableDisable: true,
    },
    {
      id: 'contact-flows',
      title: 'Contact Flows & Channels',
      description: 'Contact flow and channel management permissions.',
      items: [
        { id: 'ContactFlows', label: 'Contact Flows' },
        { id: 'ContactFlowModules', label: 'Contact Flow Modules' },
        { id: 'Prompts', label: 'Prompts' },
        { id: 'Bots', label: 'Bots' },
        { id: 'PhoneNumbers', label: 'Phone Numbers' },
        { id: 'EmailAddresses', label: 'Email Addresses' }
      ],
      hasEnableDisable: false,
    },
    {
      id: 'analytics',
      title: 'Analytics & Reports',
      description: 'Analytics, metrics, and reporting permissions.',
      items: [
        { id: 'AccessMetrics', label: 'Access Metrics' },
        { id: 'ContactSearch', label: 'Contact Search' },
        { id: 'MetricsReports', label: 'Metrics Reports' },
        { id: 'ReportsAdmin', label: 'Reports Admin' },
        { id: 'Rules', label: 'Rules' },
        { id: 'RulesGenerativeAI', label: 'Rules Generative AI' }
      ],
      hasEnableDisable: false,
    }
  ];

  return (
   
        <Container className="addhour-content-container">
       
             <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
      {/* Back Arrow in a circular button */}
      <IconButton
        onClick={onClose}
        size="medium"
        sx={{
          border: "1px solid #ccc",       // border color
          borderRadius: "50%",            // makes it circular
          padding: 1,                     // inner spacing
          bgcolor: "#f5f5f5",             // background color
          "&:hover": { bgcolor: "#e0e0e0" } // hover effect
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    
      {/* Title */}
      <Typography variant="h4" className="phone-text">
        Add Security Profile
      </Typography>
    </Box>
    
    <div className="quick-form-section">
      <Box className="form-section">
        <Box
          display="flex"
          gap={2}
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          <TextField
            fullWidth
            label="Name"
           
            required
            value={profileName}
            onChange={handleProfileNameChange}
            error={error}
            helperText={error ? helperText : ""}
            className="security-form-field"
          />
          <TextField
            fullWidth
            label="Description"
            
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="security-form-field"
          />
        </Box>
      </Box>

      <Box sx={{ mt: 4 }}>
        {permissionSections.map((section) => (
          <Accordion key={section.id}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box>
                <Typography className="section-title" align="left">{section.title}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {section.description}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <PermissionTable
                items={section.items}
                hasEnableDisable={section.hasEnableDisable}
                permissions={permissions}
                togglePermission={togglePermission}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box className="buttons-addhour" sx={{ display: "flex", gap: 2, mt: 2 }}>
        <Button
          onClick={handleCancel}
          variant="outlined"
         disabled={actionClicked === "save" || cancelButtonLoading}
               >
                 {actionClicked === "cancel" ? <CircularProgress size={18} /> : "Cancel"}
                 </Button>
        <Button
          onClick={AddSecurityProfiles}
          variant="contained"
          color="primary"
           disabled={actionClicked === "cancel" || loading}
                >
                  {actionClicked === "save" ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    "Save"
                  )}
                  </Button>
      </Box>
    </div>
    </Container>
  );
};

export default AddProfilePage;